// extracted by mini-css-extract-plugin
export default {"productsContainer":"mi1Et","product":"ky9qI","productsList":"goxeU"};